import { Heading, Fineprint } from '@flixbus/honeycomb-react';

import styles from './voucher-info.module.scss';
import { ReactElement } from 'react';

export interface InfoDisplayProps {
  title?: string | ReactElement;
  fields: {
    label?: string;
    value: ReactElement | string | null | undefined;
  }[];
  message?: { icon: ReactElement; value: string } | null | undefined;
}

const InfoDisplay = ({ title, fields, message }: InfoDisplayProps) => {
  return (
    <div>
      <div className={styles.infoDisplay}>
        <Heading flushSpace extraClasses={styles.title} size={3}>
          {title}
        </Heading>
        <div>
          {fields.map((f, i) => {
            if (!f.value) return null;

            return (
              <div className={styles.values} key={i}>
                {f.label && <label className={styles.label}>{f.label}</label>}
                <strong className={styles.value}>{f.value}</strong>
              </div>
            );
          })}
          {message && (
            <div className={styles.values}>
              {message.icon}
              <Fineprint className={styles.messageText}>{message.value}</Fineprint>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoDisplay;
